import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ProposalTabs from "../../pages/client/Enrollment/component/ProposalTabs";
import ConfirmationProposalPopUp from "../../pages/client/Enrollment/component/ConfirmationProposalPopUp";
import {va} from "../../utils/commonUtils";
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { AccountType } from '../../constants';


type ProposalProps = {
    activeProposalTab: number,
    enableActions: boolean,
    setViewApproveProposal: Function | any,
    onClose: Function | any,
    onRejectProposal: Function | any,
    openProposalPdf?: string,
    proposalPdf: any,
    setActiveProposalTab: Function,
    setEnableActions: Function,
    title: string,
    viewApproveProposal: boolean,
    handleRequestModification: Function,
    approveProposal: Function,
    approvalVal?: number | null, // actionId
    modificationVal?: string | null, // enrollmentId
    paymentFrequency: string,
    clientPolicyId?:string
    setCallingFromParent?: Function;
};

const Proposal: React.FC<ProposalProps> = (props) => {
    const { user }: any = useSelector((state: RootState) => state.auth);
    const isClientParent = user && user.isParent && (user.role === AccountType.Individual || user.role === AccountType.Multilife);
    const {
        activeProposalTab,
        approvalVal,
        approveProposal,
        enableActions,
        handleRequestModification,
        modificationVal,
        onClose,
        onRejectProposal,
        openProposalPdf,
        paymentFrequency,
        proposalPdf,
        setActiveProposalTab,
        setEnableActions,
        setViewApproveProposal,
        title,
        viewApproveProposal,
        setCallingFromParent
    } = props;
    const useStyles = makeStyles(theme => ({
        closeButton: {
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    }));

    console.info({openProposalPdf});

    const classes = useStyles();

    return (
            <React.Fragment>
            <Dialog
                    aria-describedby="Enrollment process"
                    aria-labelledby="Enrollment Home"
                    fullWidth={true}
                    maxWidth={"lg"}
                    open={!!proposalPdf}
            >
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon/>
                </IconButton>
                <DialogTitle id="customized-dialog-title">
                    {title}
                </DialogTitle>

                <DialogContent className="pr30 pl30" dividers>
                    <Grid container justify="center" spacing={2}>
                        {
                            // openProposalPdf === "WAITING_API_RESPONSE" &&
                            // <CommonLoader/>
                        }
                        {
                            // openProposalPdf !== "WAITING_API_RESPONSE" && va(proposalPdf) &&
                            // !!va(openProposalPdf) &&
                            <ProposalTabs
                                    clientPolicyId={props.clientPolicyId}
                                    activeProposalTab={activeProposalTab}
                                    callBack={() => setEnableActions(true)}
                                    proposalObjArr={proposalPdf}
                                    setActiveProposalTab={setActiveProposalTab}
                            />
                        }
                    </Grid>
                </DialogContent>
                {
                        enableActions &&
                        <DialogActions >
                            <Grid container style={{justifyContent: isClientParent ? 'space-between' : 'flex-end', alignItems: 'center'}}>
                               {
                                isClientParent && 
                                    <Grid item>
                                        <Button 
                                            color="primary"
                                            className="floatLeft"
                                            size='small'
                                            variant='outlined'
                                            type={'button'}
                                            onClick={() => {
                                                handleRequestModification(modificationVal);
                                                setCallingFromParent && setCallingFromParent(true);
                                            }}>
                                            {`Request Modification`}
                                        </Button>
                                    </Grid>
                                }
                                <Grid item alignItems='flex-end'>
                                    <Button
                                            color="primary"
                                            className="floatLeft"
                                            onClick={() => setViewApproveProposal(true)}
                                            variant="contained"
                                    >
                                        Approve
                                    </Button>
                                    <Button
                                            className="floatRight ml5"
                                            color="secondary"
                                            onClick={onRejectProposal}
                                            variant="contained"
                                    >
                                        Cancel
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                }
            </Dialog>
                <ConfirmationProposalPopUp
                        changeModification={`Request Modification`}
                        popupStatus={viewApproveProposal}
                        proceed={`Approve`}
                        setApprove={approveProposal}
                        setApproveVal={approvalVal}
                        setModification={handleRequestModification}
                        setModificationVal={modificationVal}
                        setPopupStatus={setViewApproveProposal}
                        setCallingFromParent={setCallingFromParent}
                        text1={`Your Client has chosen to pay a ${paymentFrequency} contribution. If this is correct, please approve this proposal.`}
                        text2={`If your client would like to change their ${paymentFrequency} contribution amount or frequency, please request a modified proposal with the correct amount and/or frequency.`}
                />
            </React.Fragment>
    );
};

export default Proposal;
